declare var window: any;

const PushEvent = {
  mounted() {
    window.pushEventHook = this;
  },
};

export default PushEvent;
